import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-2xl font-medium text-gray-900" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "text-red-500 mt-3 mb-3 absolute" }
const _hoisted_9 = { class: "flex items-center mt-3 text-sm text-brand-600" }
const _hoisted_10 = { class: "link" }

import { 
		Auth
	} from '@/api/Auth'

	// languages
	import { 
		useI18n
	} from 'vue-i18n'

	// router
	import {
		useRouter
	} from 'vue-router'

	// vue
	import {
		ref
	} from 'vue'

	
	const __default__ = { name: 'UpdatePasswordForm' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// api
	const {t} = useI18n()

	const router = useRouter()
	
	const email = ref("")
	const currentPassword = ref("")
	const newPassword = ref("")
	const verifyNewPassword = ref("")
	const error = ref(false)
	const errorMsg = ref('')
	const formLoading = ref(false)
	const inputEmail = ref<null | {valid: Boolean}>(null)
	const inputPassword = ref<null | {valid: Boolean}>(null)
	const inputNewPassword = ref<null | {valid: Boolean}>(null)
	const inputNewPasswordConfirm = ref<null | {valid: Boolean}>(null)
	const passwordConfirmMessage = ref(t('updatePassword.newPasswordValidation'))

	async function updatePassword() {
		formLoading.value = true
		let formError = false
		if (newPassword.value != verifyNewPassword.value) {
			document.getElementById('verifyNewPassword')?.focus()
			passwordConfirmMessage.value = t('updatePassword.passwordMismatch')
			if(inputNewPasswordConfirm.value)inputNewPasswordConfirm.value.valid = false
			formError = true
		}
		if (verifyNewPassword.value == "") {
			document.getElementById('verifyNewPassword')?.focus()
			if(inputNewPasswordConfirm.value)inputNewPasswordConfirm.value.valid = false
			formError = true
		}
		if (newPassword.value == "") {
			document.getElementById('newPassword')?.focus()
			if(inputNewPassword.value)inputNewPassword.value.valid = false
			formError = true
		}
		if (currentPassword.value == "") {
			document.getElementById('currentPassword')?.focus()
			if(inputPassword.value)inputPassword.value.valid = false
			formError = true
		}
		if (email.value == "") {
			document.getElementById('email')?.focus()
			if(inputEmail.value)inputEmail.value.valid = false
			formError = true
		}
		
		if(formError) {
			formLoading.value = false
			return
		}

		try {
			let response = await Auth.changePassword(email.value, currentPassword.value, newPassword.value)
			if(response.success === false) {
				error.value = true
				errorMsg.value = response.messages[0].message || t('updatePassword.error')
				formLoading.value = false
				return
			}
			formLoading.value = false
			router.push({name: 'Jobs'})
		} 
		catch(e) {
			console.log(e)
			// do something with the error
		}
	}

	const showCurrentPassword = ref(false)

	function toggleShowCurrentPassword() {
		const passwordField = document.querySelector('#currentPassword')

		if(passwordField?.getAttribute('type') === 'password') {
			passwordField.setAttribute('type', 'text')
			showCurrentPassword.value = true
		}
		else{
			passwordField?.setAttribute('type', 'password')
			showCurrentPassword.value = false
		}
	}

	const showNewPassword = ref(false)

	function toggleShowNewPassword() {
		const passwordField = document.querySelector('#newPassword')

		if(passwordField?.getAttribute('type') === 'password') {
			passwordField.setAttribute('type', 'text')
			showNewPassword.value = true
		}
		else{
			passwordField?.setAttribute('type', 'password')
			showNewPassword.value = false
		}
	}

	const showVerifyPassword = ref(false)

	function toggleShowVerifyPassword() {
		const passwordField = document.querySelector('#verifyNewPassword')

		if(passwordField?.getAttribute('type') === 'password') {
			passwordField.setAttribute('type', 'text')
			showVerifyPassword.value = true
		}
		else{
			passwordField?.setAttribute('type', 'password')
			showVerifyPassword.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_EyeIcon = _resolveComponent("EyeIcon")!
  const _component_EyeSlashIcon = _resolveComponent("EyeSlashIcon")!
  const _component_tw_button = _resolveComponent("tw-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)('updatePassword.title')), 1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('updatePassword.instructions')), 1)
    ]),
    _createElementVNode("form", {
      class: "mt-8",
      onSubmit: _withModifiers(updatePassword, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_tw_input, {
            modelValue: email.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            id: "email",
            required: true,
            type: "email",
            label: _unref(t)('login.email'),
            validation: _unref(t)('login.emailValidation'),
            class: "text-md"
          }, null, 8, ["modelValue", "label", "validation"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_tw_input, {
            modelValue: currentPassword.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPassword).value = $event)),
            id: "currentPassword",
            ref_key: "inputPassword",
            ref: inputPassword,
            required: true,
            type: "password",
            label: _unref(t)('updatePassword.currentPassword'),
            validation: _unref(t)('updatePassword.currentPasswordValidation'),
            class: "text-md"
          }, {
            trailing_inline: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: toggleShowCurrentPassword,
                class: "border-none bg-transparent hover:bg-transparent"
              }, [
                (!showCurrentPassword.value)
                  ? (_openBlock(), _createBlock(_component_EyeIcon, {
                      key: 0,
                      class: "h-5"
                    }))
                  : (_openBlock(), _createBlock(_component_EyeSlashIcon, {
                      key: 1,
                      class: "h-5"
                    }))
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "label", "validation"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_tw_input, {
            modelValue: newPassword.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newPassword).value = $event)),
            id: "newPassword",
            ref_key: "inputNewPassword",
            ref: inputNewPassword,
            required: true,
            type: "password",
            label: _unref(t)('updatePassword.newPassword'),
            validation: _unref(t)('updatePassword.newPasswordValidation'),
            class: "text-md"
          }, {
            trailing_inline: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: toggleShowNewPassword,
                class: "border-none bg-transparent hover:bg-transparent"
              }, [
                (!showNewPassword.value)
                  ? (_openBlock(), _createBlock(_component_EyeIcon, {
                      key: 0,
                      class: "h-5"
                    }))
                  : (_openBlock(), _createBlock(_component_EyeSlashIcon, {
                      key: 1,
                      class: "h-5"
                    }))
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "label", "validation"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_tw_input, {
            modelValue: verifyNewPassword.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((verifyNewPassword).value = $event)),
            id: "verifyNewPassword",
            label: _unref(t)('updatePassword.confirmNewPassword'),
            ref_key: "inputNewPasswordConfirm",
            ref: inputNewPasswordConfirm,
            required: true,
            type: "password",
            validation: passwordConfirmMessage.value,
            class: "text-md"
          }, {
            trailing_inline: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: toggleShowVerifyPassword,
                class: "border-none bg-transparent hover:bg-transparent"
              }, [
                (!showVerifyPassword.value)
                  ? (_openBlock(), _createBlock(_component_EyeIcon, {
                      key: 0,
                      class: "h-5"
                    }))
                  : (_openBlock(), _createBlock(_component_EyeSlashIcon, {
                      key: 1,
                      class: "h-5"
                    }))
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "label", "validation"])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", null, _toDisplayString(errorMsg.value), 1)
      ], 512), [
        [_vShow, error.value]
      ]),
      _createVNode(_component_tw_button, {
        class: "w-full btn-brand mt-10",
        type: "submit",
        disabled: formLoading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('resetPassword.submit')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: {name: 'Login'},
            class: "link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('resetPassword.returnToLoginScreen')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ], 32)
  ], 64))
}
}

})